
import {throwError as observableThrowError,  Observable } from 'rxjs';

import {catchError, map} from 'rxjs/operators';
import { AuthHttp } from '../../admin/services/token.service';
// import { AppConstant } from './../../shared/constant/app.constant';
import { Injectable } from '@angular/core';


import { AppConfigService } from '../../shared/services/app.config.service';

let AppConstant: any = {};

@Injectable()
export class EndOfDayService {
    constructor(private http: AuthHttp, private appConfigServ: AppConfigService) {
        AppConstant = appConfigServ;
    }

    getPublicHoliday() {
        return this.http.get(`setups/public-holiday`).pipe(
            map((res: any) => res),
            catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }

    getnextApplicationDate() {
        return this.http.get(`setups/application-date`).pipe(
            map((res: any) => res),
            catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }


    getApplicationEODLastRefreshedDate() {
        return this.http.get(`setups/application-last-refreshed-date`).pipe(
            map((res: any) => res),
            catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }

    save(body) {
        let bodyObj = JSON.stringify(body);
        return this.http.post(`setups/public-holiday`, bodyObj).pipe(
            map((res: any) => res),
            catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }

    getEndOfDay() {
        return this.http.get(`admin/end-of-day`).pipe(
            map((res: any) => res),
            catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }


    // getEndofdayOperationLog(eodDate) {
    //     return this.http.get(`admin/get_endofday_operation_log/${eodDate}`)
    //         .map((res: any) => res)
    //         .catch((error: any) => Observable
    //             .throw(error.error || 'Server error'));
    // }

    getEndofdayOperationLog(body) {
        let bodyObj = JSON.stringify(body);
        return this.http.post(`admin/get_endofday_operation_log`, bodyObj).pipe(
            map((res: any) => res),
            catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }


    getEndofdayOperationLogMonitoring(body) {
        let bodyObj = JSON.stringify(body);
        return this.http.post(`admin/get_endofday_operation_log_monitoring`, bodyObj).pipe(
            map((res: any) => res),
            catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }


    
    deactivateInactiveUsers() {
        return this.http.get(`admin/deactivate-inactive-users`).pipe(
            map((res: any) => res),
            catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }

    logOutActiveUsers() {
        return this.http.get(`logout-all-users`).pipe(
            map((res: any) => res),
            catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }

   // ProcessRepaymentFromStaging

    runEodBukPosting() {
        return this.http.get(`admin/process-repayment-from-staging`).pipe(
            map((res: any) => res),
            catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }
    
    refreshLoanClassification() {
        return this.http.get(`admin/refresh-loan-classification`).pipe(
            map((res: any) => res),
            catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }


    runEodOperation(formObj) {
        let bodyObj = JSON.stringify(formObj);
        return this.http.post(`admin/end-of-day`, bodyObj).pipe(
            map((res: any) => res),
            catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }
    
    loanYearWeekends(formObj) {
        let bodyObj = JSON.stringify(formObj);
        return this.http.post(`setups/public-holiday/weekends-in-a-year`, bodyObj).pipe(
            map((res: any) => res),
            catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }

    update(body, id) {
        let bodyObj = JSON.stringify(body);
        return this.http.put(`setups/public-holiday/${id}`, bodyObj).pipe(
            map((res: any) => res),
            catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }
    delete(id) {
        return this.http.delete(`setups/public-holiday-delete/${id}`).pipe(
            map((res: any) => res),
            catchError((error: any) => observableThrowError(error.error || 'Server error')),);
    }

}